var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinscore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71573e-08 23.3046H15.6963C15.6963 35.4013 15.6963 24.4576 15.6963 36.5544C16.3437 45.6045 23.764 52.7467 32.5861 53.7758L36.4043 53.7893L44.9408 69H32.3439C23.1191 69 14.7704 64.1497 8.81968 57.128C2.81506 50.0421 -0.000253774 41.907 1.71573e-08 32.583V23.3046Z",
    fill: "#796DEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -0.000135344H15.8882V16.4502H0V-0.000135344Z",
    fill: "#898989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6055 0.0175786V15.6376H37.1144C43.5864 15.6376 50.1736 20.984 52.5829 27.2977C53.5323 29.7865 53.5396 32.1551 53.5396 34.7548L68.9827 60.7744L69.0001 35.2522C69.0191 23.6982 64.1028 12.9365 54.6865 6.27785C48.1256 1.63803 41.7853 -0.0131566 34.1386 -0.000348909L23.6055 0.0175786Z",
    fill: "#796DEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.954 23.7617C41.4714 23.7617 46.7566 28.8775 46.7566 35.1856C46.7566 41.4938 41.4714 46.6094 34.954 46.6094C28.4367 46.6094 23.1514 41.4938 23.1514 35.1856C23.1514 28.8775 28.4367 23.7617 34.954 23.7617Z",
    fill: "#898989"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8583 27.8992L67.6383 69H50.0674L26.3291 27.5447C26.3291 27.5447 28.0529 25.6672 30.6285 24.5714C32.4116 23.8126 34.9355 23.6559 36.2131 23.8211C37.6118 24.0016 39.4731 24.5145 40.901 25.3835C42.6616 26.4547 43.8583 27.8992 43.8583 27.8992Z",
    fill: "#796DEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinscore);
export default __webpack_public_path__ + "static/media/WINSCORE.c15f9d6b05f4911b0eada3671635636d.svg";
export { ForwardRef as ReactComponent };